/* Envision - smooth scroll into element with ID and offset the header and announcement bar heights */

function scrollIntoElm(id) {
  const element = document.getElementById(id);
  const announcementBar = document.getElementById('shopify-section-static-announcement');
  const header = document.getElementById('shopify-section-static-header');
  if (element)
  {
    const elementPosition = element.getBoundingClientRect().top;
    const headerHeight = header?.offsetHeight || 0;
    const announcementBarHeight = announcementBar?.offsetHeight || 0;
    window.scrollTo({
      top: elementPosition + window.pageYOffset - (headerHeight + announcementBarHeight),
      behavior: 'smooth',
    });
  }
}
document.querySelectorAll('a[href^="#"]:not(a[href="#"])').forEach(function(anchor) {
  anchor.addEventListener('click', function(event) {
    event.preventDefault();
    scrollIntoElm(anchor.getAttribute('href').substring(1))
  });
});